import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const m = ({
  title: e,
  titleId: o,
  ...c
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M345.033 480.783c12.821-67.371 67.072-121.749 134.443-134.549 43.904-8.341 85.504.299 119.637 20.288L365.086 600.57c-19.861-34.219-28.416-75.84-20.053-119.787m-22.272 282.795c.128.064.277.128.405.213L425.225 661.69a1.64 1.64 0 0 1-.384-.192l234.965-234.965c.085.107.149.256.213.384L771.55 315.386a4.146 4.146 0 0 1-.32-.277l80.597-80.597c16.491-16.512 16.64-43.221.32-59.925-16.64-16.981-43.947-17.131-60.757-.32l-89.792 89.792c-51.029-29.291-112.875-49.024-188.117-49.024-120.96 0-207.573 51.179-269.867 111.36-62.315 60.16-100.288 129.344-124.032 165.376-4.779 7.232-7.147 15.467-7.125 23.701 0 8.235 2.411 16.448 7.189 23.68 23.787 35.861 61.76 104.597 124.053 164.331 3.115 2.965 6.549 5.803 9.749 8.725l-80.128 80.128c-16.683 16.683-16.683 43.712 0 60.416 16.619 16.64 43.605 16.64 60.245 0l89.195-89.173zm584.605-272.66c-21.312-32.149-54.059-90.731-105.323-145.707L678.011 469.264c6.72 24.576 8.192 51.349 2.923 79.04-12.843 67.371-67.072 121.749-134.443 134.549-27.691 5.269-54.464 3.755-79.04-3.029L363.28 783.995c43.051 18.496 92.779 30.037 150.336 30.037 121.067 0 207.573-51.008 269.803-110.976 62.208-59.989 100.139-128.939 123.947-164.864 4.8-7.211 7.168-15.403 7.168-23.637a42.543 42.543 0 0 0-7.168-23.637",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = i(m);
export {
  n as default
};
